<template>
  <modal :show="show" @change="$emit('change',$event)" width="700" :headerClass="currentLocale === 'ru' ? 'bg-main-orange white--text helvetica-roman fs-18' : 'bg-main-orange white--text rubik-medium fs-18'">
      <template v-slot:header>
        <span>{{$t('client')}}</span>
      </template>
      <template v-slot:main>
        <div class="modal-content">
          <div class="tes-text modal-content-text">
            {{$t('modals.modalReadingsInfo.infoPart1')}}
                  <br />
                  <span class="tes-orange-text">{{$t('modals.modalReadingsInfo.infoPart2')}} </span>{{$t('modals.modalReadingsInfo.infoPart3')}}
          </div>
        </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mapGetters } from "vuex";

export default {
  name: "ModalReadingsInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("locale",["currentLocale"]),
  },
  methods: {},
  created() {},
  watch: {}
};
</script>

<style lang="scss">
.modal-content-text {
  text-align: center;
  padding: 10px;
}
</style>